import { MetabaseDashboard } from './MetabaseDashboard'

export const MetabaseAccountOverview = () => {
  const dashboardId = process.env.REACT_APP_METABASE_ACCOUNT_DASHBOARD_ID

  if (!dashboardId) {
    // eslint-disable-next-line no-console
    console.error('Dashboard ID is not defined')
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="rounded bg-coolGray-100 px-6 py-4 text-base-700">
          Unable to load the account overview dashboard. The dashboard
          configuration is missing.
        </div>
      </div>
    )
  }

  return <MetabaseDashboard dashboardId={dashboardId} />
}
